/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

export type LanguageOutReason = typeof LanguageOutReason[keyof typeof LanguageOutReason] | null;


export const LanguageOutReason = {
  not_transcribable: 'not_transcribable',
  feature_not_in_plan: 'feature_not_in_plan',
} as const;
